import { Component, inject } from "@angular/core";
import { NZ_MODAL_DATA, NzModalRef } from "ng-zorro-antd/modal";
import { SharedModule } from "../../../../shared/shared.module";
import { JobsFormComponent } from "../../../../shared/forms/jobs-form/jobs-form.component";

interface AddJobModalData {
  projectId: string;
  projectName: string;
}

@Component({
  selector: "app-add-job",
  templateUrl: "./add-job-dialog.component.html",
  imports: [SharedModule, JobsFormComponent],
})
export class AddJobDialogComponent {
  readonly #modal = inject(NzModalRef);
  readonly nzModalData: AddJobModalData = inject(NZ_MODAL_DATA);

  get projectName(): string {
    return this.nzModalData.projectName;
  }

  onCancel = () => this.#modal.destroy();

  onSubmitSuccess = () => this.#modal.destroy(true);
}
